<template>
  <div class="information">
    <div class="container">
      <Points v-if="displaying === 1" />
      <Target v-if="displaying === 2" />
      <Controls
        :displaying="displaying"
        :max="max"
        v-on:inc="inc"
        v-on:dec="dec"
      />
    </div>
  </div>
</template>

<script>
import Points from "@/components/top-selling/information/Points.vue";
import Target from "@/components/top-selling/information/Target.vue";
import Controls from "@/components/shared/information/Controls.vue";

export default {
  name: "Information",
  components: {
    Points,
    Target,
    Controls
  },
  data() {
    return {
      displaying: 1,
      max: 2
    };
  },
  methods: {
    inc() {
      this.displaying = this.displaying === 1 ? this.max : this.displaying - 1;
    },
    dec() {
      this.displaying = this.displaying === this.max ? 1 : this.displaying + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.information {
  grid-area: information;
  padding: 1rem;
  // height: 100%;
  // border: 1px solid red;
}

.container {
  height: 100%;
  background: $paper;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media screen and (max-width: 1024px) {
  .information {
    // padding: 2rem;
  }

  .container {
    height: 100%;
  }
}
@media screen and (max-width: 812px) {
  .information {
    padding: 0.5rem 0;
  }
}
</style>
